import {
  GET_AUTH_INFO,
  GET_AUTH_INFO_ERROR,
  GET_AUTH_INFO_SUCCESS,
  GET_PUBLIC_TOKEN,
  GET_PUBLIC_TOKEN_ERROR,
  GET_PUBLIC_TOKEN_SUCCESS
} from './AuthorizationProvider.actions'

const authorizationProviderState = {
  authInfo: {
    loading: false,
    error: undefined,
    orgCode: '',
    userCode: '',
    userName: '',
    userType: '',
    sellerDni: ''
  },
  publicToken: {
    loading: false,
    error: undefined
  }
}

/**
 * The authorization provider's reducer.
 */
const authorizationProviderReducer = (state = authorizationProviderState, { payload, type }) => {
  switch (type) {
    case GET_PUBLIC_TOKEN: {
      return { ...state, publicToken: { ...state.publicToken, loading: true } }
    }
    case GET_PUBLIC_TOKEN_ERROR: {
      return { ...state, publicToken: { error: payload.error, loading: false } }
    }
    case GET_PUBLIC_TOKEN_SUCCESS: {
      return { ...state, publicToken: { ...state.publicToken, loading: false } }
    }
    case GET_AUTH_INFO: {
      return { ...state, authInfo: { ...state.authInfo, loading: true } }
    }
    case GET_AUTH_INFO_ERROR: {
      return { ...state, authInfo: { ...state.authInfo, error: payload.error, loading: false } }
    }
    case GET_AUTH_INFO_SUCCESS: {
      return { ...state, authInfo: { ...state.authInfo, ...payload.authInfo, loading: false } }
    }
    default: {
      return state
    }
  }
}

export default authorizationProviderReducer
